import type { DerivedIdealCategory } from '../../deriveSipPlansView'
import { CategoryCard } from '../../../../lumpsum/plans-list/lumpsum-ui-components/CategoryCard'
import { PlansCategoryRangeTrailing } from '../../../../lumpsum/plans-list/lumpsum-ui-components/PlansCategoryRangeTrailing'
import { SipCategoryErrorState } from '../../sip-ui-components/SipCategoryErrorState'
import { IdealSipFundCard } from './cards/IdealSipFundCard'
import { buildPlanAllocationRangeLabel } from '../../../../display-values/lumpsumPlanPercentage'

type IdealSipCategoryCardProps = {
  category: DerivedIdealCategory
  categoryIndex: number
  noDivider?: boolean
}

export function IdealSipCategoryCard({
  category,
  categoryIndex,
  noDivider = false
}: IdealSipCategoryCardProps) {
  const categoryId = category?.categoryId ?? `ideal-category-${categoryIndex}`
  const label = category?.categoryName ?? ''
  const categoryAllocationRangeLabel = buildPlanAllocationRangeLabel({ idealAllocation: category?.idealAllocationPercentage })
  const funds = category?.idealSips ?? []

  return (
    <CategoryCard
      label={label}
      trailing={<PlansCategoryRangeTrailing label={categoryAllocationRangeLabel} showIdealRangeLabel={false} />}
      noDivider={noDivider}
    >
      {category.hasCategoryError ? (
        <SipCategoryErrorState />
      ) : (
        <div className="flex flex-col gap-5 py-5">
          {funds.map((fund, fundIndex) => (
            <IdealSipFundCard
              key={`${fund?.isin ?? 'fund'}-${fundIndex}`}
              fund={fund}
              showBottomDivider={fundIndex < funds.length - 1}
            />
          ))}
        </div>
      )}
    </CategoryCard>
  )
}
